import React from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";

//
import IconWrapper from "../icon-wrapper/IconWrapper";

export default function DoctorCard({
  id,
  img,
  name,
  spec,
  socials,
  imagePosition = "center top",
  imageScale = 1,
}) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  function handleNavigate(url) {
    navigate(url);
  }

  return (
    <StyledDoctorCard onClick={() => handleNavigate("/about/doctor/" + id)}>
      <div className="doctor-card__top">
        <img
          src={img}
          alt={t(name)}
          style={{
            "--doctor-img-position": imagePosition,
            "--doctor-img-scale": imageScale,
            "--doctor-img-hover-scale": imageScale + 0.04,
          }}
        />
      </div>
      <div className="doctor-card__bottom">
        <h2 dangerouslySetInnerHTML={{ __html: "Dr. " + t(name) }} />
        <p>{t(spec)}</p>
        <ul className="doctor-card__socials">
          <li>
            <a href={socials.facebook}>
              <IconWrapper
                w={40}
                h={40}
                icon="facebook"
                iconW={20}
                iconH={20}
                animation="scale&&rotate"
              />
            </a>
          </li>
          <li>
            <a href={socials.instagram}>
              <IconWrapper
                w={40}
                h={40}
                icon="instagram"
                iconW={20}
                iconH={20}
                animation="scale&&rotate"
              />
            </a>
          </li>
          <li>
            <a href={socials.twitter}>
              <IconWrapper
                w={40}
                h={40}
                icon="youtube"
                iconW={20}
                iconH={20}
                animation="scale&&rotate"
              />
            </a>
          </li>
          <li>
            <a href={socials.telegram}>
              <IconWrapper
                w={40}
                h={40}
                icon="telegram"
                iconW={20}
                iconH={20}
                animation="scale&&rotate"
              />
            </a>
          </li>
        </ul>
      </div>
    </StyledDoctorCard>
  );
}

const StyledDoctorCard = styled.div`
  cursor: pointer;
  height: 100%;
  display: flex;
  flex-direction: column;

  .doctor-card {
    &__top {
      width: 100%;
      aspect-ratio: 1 / 1.08;
      overflow: hidden;
      line-height: 0;
      margin-bottom: 24px;
      border: 1px solid var(--border);
      background-color: var(--light-bg);
    }

    &__top img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      object-position: var(--doctor-img-position, center top);
      display: block;
      transition: transform 0.4s ease;
      transform: scale(var(--doctor-img-scale, 1));
      transform-origin: center top;
      border: none;
    }

    &__top:hover img {
      transform: scale(var(--doctor-img-hover-scale, 1.06));
    }

    &__bottom {
      display: flex;
      flex-direction: column;
      align-items: center;
      flex: 1;
    }

    &__bottom h2 {
      color: var(--title);
      text-align: center;
      font-size: var(--fs-card-title);
      font-style: normal;
      font-weight: var(--fw-semibold);
      line-height: 1.35;
      margin-bottom: 12px;
      min-height: 64px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    &__bottom p {
      color: var(--text);
      text-align: center;
      font-size: var(--fs-body-sm);
      font-style: normal;
      font-weight: var(--fw-medium);
      line-height: var(--lh-body);
      margin-bottom: 24px;
      min-height: 22px;
    }

    &__socials {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 16px;
      margin-top: auto;
    }
  }

  @media (max-width: 768px) {
    .doctor-card {
      &__top {
        aspect-ratio: 1 / 1.05;
        margin-bottom: 20px;
      }

      &__bottom h2 {
        min-height: auto;
      }
    }
  }
`;
